<script setup lang="ts">
import { computed, onMounted, shallowRef } from 'vue';
import { Api } from '@/modules/analytics/types/statistics';
import axios from 'axios';
import { formatDecimalAsCurrencyString } from '@/utils/helpers/auction-numbers';

const response = shallowRef<Api.IaResponse | null>(null);
const data = computed(() =>
  response.value === null
    ? null
    : Object.fromEntries(
        Object.entries(response.value).map(([key, value]) => [
          key,
          formatDecimalAsCurrencyString('USD', value, 2),
        ])
      )
);

async function fetchData() {
  try {
    const axiosResponse = await axios.get<Api.IaResponse>(`/api/1/analytics/dashboard/ia`);
    response.value = axiosResponse.data;
  } catch (err) {
    if (axios.isCancel(err)) {
      return;
    }
  }
}

onMounted(fetchData);
</script>

<template>
  <VCol cols="4">
    <VCard class="flex d-flex flex-column" variant="outlined">
      <VCardTitle>Collateral Amount</VCardTitle>
      <VCardSubtitle
        >This view approximates values which may be owed to the NSCC as part of the SFT clearing
        service based on the SFT transactions managed on Aurora. The estimates will not include the
        impact of transactions done away.
      </VCardSubtitle>
      <VCardText>
        <v-simple-table>
          <thead>
            <tr>
              <th></th>
              <th class="text-right">Collateral Debit</th>
              <th class="text-right">Collateral Credit</th>
            </tr>
          </thead>
          <tbody v-if="data">
            <tr>
              <td>Today</td>
              <td class="text-right">{{ data.todayIADebit }}</td>
              <td class="text-right">{{ data.todayIACredit }}</td>
            </tr>
            <tr>
              <td>Yesterday</td>
              <td class="text-right">{{ data.yesterdayIADebit }}</td>
              <td class="text-right">{{ data.yesterdayIACredit }}</td>
            </tr>
            <tr>
              <td>Difference</td>
              <td class="text-right">{{ data.differenceIADebit }}</td>
              <td class="text-right">{{ data.differenceIACredit }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </VCardText>
    </VCard>
  </VCol>
</template>
